import { FC } from "react";
import { Row, Col } from "antd";
import { ICheckbox } from "../../../ui-kit";
import styles from "../Defect.module.scss";

interface DefectCardMediaProps {
  checkedMedia: boolean;
  data: any;
}

const DefectCardMedia: FC<DefectCardMediaProps> = ({ checkedMedia, data}) => {

  return (
    <Row gutter={[15, 10]}>
      <Col span={24}>
        <ICheckbox
          checked={checkedMedia}
          label={"Публикация в СМИ"}
          disabled
        />
      </Col>
      {checkedMedia == true && data.mediaComment !== null &&
        <>
          <Col span={24}>
            <div className={styles.defect__cardLabel}>
              Комментарий СМИ
            </div>
          </Col>
          <Col span={24}>
            <div className={styles.defect__cardMediaComment}>
              <p className={styles.defect__cardValue}>
                {data.mediaComment}
              </p>
            </div>
          </Col>
        
        </>
      }
    </Row>
  );
};

export default DefectCardMedia;